import { AddressGuarantorsComponent } from './components/address-guarantors/address-guarantors.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsultantRoutingModule } from './consultant-routing.module';
import { RequestComponent } from './components/request/request.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddressComponent } from './components/address/address.component';
import { OthersComponent } from './components/others/others.component';
import { BaseFormComponent } from './components/base-form/base-form.component';
import { IdCardImageComponent } from './components/id-card-image/id-card-image.component';


@NgModule({
  declarations: [RequestComponent, AddressComponent, AddressGuarantorsComponent, OthersComponent, BaseFormComponent, IdCardImageComponent],
  imports: [
    CommonModule,
    ConsultantRoutingModule,
    SharedModule
  ]
})
export class ConsultantModule { }
